const replaceLocation = (url: string) => {
    window.location.replace(url);
};

export const locationHelpers = {
    replaceLocation,
};
